"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var ServiceDetails_1 = __importDefault(require("./ServiceDetails"));
var ServicesTableRow_1 = __importDefault(require("./styles/ServicesTableRow"));
var ServicesListRow = function (_a) {
    var item = _a.item, onClickRow = _a.onClickRow, selectedItem = _a.selectedItem, _b = _a.isAdmin, isAdmin = _b === void 0 ? false : _b;
    return (
    // undefined means noneSelected, the 3 options undefined, true and false all have different styles
    // ToDo: see why passing selected
    // <ServicesTableRow isClickable selected={selectedItem ? item.id === selectedItem.id : undefined}>
    (0, jsx_runtime_1.jsx)(ServicesTableRow_1.default, __assign({ isClickable: true, tabIndex: 0 }, { children: (0, jsx_runtime_1.jsx)(ServiceDetails_1.default, { item: item, onClickRow: function (selectedStat) { return onClickRow(selectedStat); }, isPartialView: !!selectedItem, isAdmin: isAdmin }) })));
};
exports.default = react_1.default.memo(ServicesListRow);
